import React from 'react'
import Wrapper from './src/components/Wrapper'
import './global.css'
import aetnaTheme from '../../gatsby-theme-clearlink/aetnaTheme'

// wrapRootElement is part of the Gatsby API, and thus cannot be the default export
/* eslint-disable import/prefer-default-export, react/jsx-filename-extension */
export const wrapPageElement = ({ element, props }) => {
  let customTheme
  if (props?.pageContext.page.template?.identifier === 'Aetna') {
    customTheme = aetnaTheme
  }

  return <Wrapper customTheme={customTheme}>{element}</Wrapper>
}
